/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { useEffect } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { Stack } from '@atlaskit/primitives/compiled';
import {
	DynamicSurfaceView,
	useAICurrentView,
	useViewAIActions,
} from '@atlassian/ai-smart-button-api';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { useProfileController } from '@atlassian/conversation-assistant-store';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { AIActions } from '../ai-actions';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { AIFeatureView } from '../ai-feature-view';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { ObjectSidebar } from '../common/types/object-sidebar-types';

export type InternalViews = 'dynamic-surface';
import { AIDynamicSurfaceContextProvider } from './AIDynamicSurfaceContext';
import { useUpdateDynamicSurfacePanelHeaderComponents } from './useDynamicSurfacePanel';

export type AIDynamicSurfaceProps = {
	objectSidebar: ObjectSidebar;
};

const styles = cssMap({
	container: {
		height: '100%',
	},
});

export const AIDynamicSurfaceInner = ({ objectSidebar }: AIDynamicSurfaceProps) => {
	const { changeView } = useViewAIActions();
	const currentView = useAICurrentView();
	useUpdateDynamicSurfacePanelHeaderComponents(objectSidebar);
	useEffect(() => {
		return () => {
			changeView(DynamicSurfaceView.Default);
		};
	}, [changeView]);
	const profileData = useProfileController();
	const name = profileData.name.split(' ')[0];

	if (currentView === DynamicSurfaceView.Default) {
		return (
			<Stack grow="fill" testId="ai-dynamic-surface" xcss={styles.container}>
				{/* AIAction will render both actions and studio sections */}
				<AIActions name={name} objectSidebar={objectSidebar} />
			</Stack>
		);
	}

	return <AIFeatureView objectSidebar={objectSidebar} view={currentView?.viewConfig} />;
};

export const AIDynamicSurface = ({ objectSidebar }: AIDynamicSurfaceProps) => {
	return (
		<AIDynamicSurfaceContextProvider>
			<AIDynamicSurfaceInner objectSidebar={objectSidebar} />
		</AIDynamicSurfaceContextProvider>
	);
};
